exports.Stream = require('./lib/stream');
exports.encode = require('./lib/encode');
exports.decode = require('./lib/decode');